/*
 * @Author: Src
 * @Date: 2024-12-17 18:34:56
 * @LastEditTime: 2024-12-20 14:13:26
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/common/enum/shop.ts
 * @Description: 门店枚举
 */
export enum EShopField {
    kaId = 'ka_id', // kafkaId
    id = 'id', // 记录ID
    city = 'adcode', // 城市
    shopName = 'shop_name', // 门店名称
    shopLicense = 'shop_license_url_id', // 营业执照
    showPrice = 'show_price', // 城市刊例价
    entranceFee = 'entrance_fee', // 入驻费用
    businessYear = 'business_year', // 开业时间
    businessHours = 'business_hours', // 营业时间
    alipayName = 'alipay_name', // 门店收款支付宝实名
    alipayAccount = 'alipay_account', // 门店收款支付宝账号
    shopowerPhone = 'shopowner_phone', // 门店店长手机号
    platformPhone = 'platform_phone', // 平台联系电话
    poi = 'poi', // 高德地图poi
    bossPhone = 'boss_phone', // 老板电话
    cashierPhone = 'cashier_phone', // 收银员手机号
    nationalEmblemPhotos = 'national_emblem_photos_url_id', // 身份证国徽面（正面）
    portraitPhotos = 'portrait_photos_url_id', // 身份证人像面（反面）
    sendTime = 'send_time', // 赠送天数
    auditStatus = 'audit_status', // 审核状态
}
